import styled from 'styled-components';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash-es';
import { Paper, SimplePopoverPlainOption, EmptyState, MobileTable } from '@dev/ee-components';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { useAccessLevel } from '@/services/hooks/useAccessLevel';
import i18n from '@/../i18n';
import { getCheckoutsStore } from '@/store/checkouts/actions';
import { DropdownOptions } from '@/store/checkouts/types';
import { useMobileTableRows } from '../../hooks/useMobileTableRows/index';
import { useDropdownActions } from '../../hooks/useDropdownActions';


const MobileTableContainer = styled.div`
    margin-top: 24px;

    & > div {
        padding-bottom: 2px;
    }
`;

const getDropdownTableOptions = (canModifyCheckouts: boolean): SimplePopoverPlainOption[] => [
    {
        label: i18n.t('editcheckout'),
        value: DropdownOptions.EditCheckout,
    },

    {
        label: i18n.t('checkoutlink'),
        value: DropdownOptions.CheckoutLink,
    },
    ...(canModifyCheckouts ? [{
        label: i18n.t('delete'),
        color: '#ff0000',
        value: DropdownOptions.Delete,
    }] : []),
];

export const MobileCheckoutsTable = (): JSX.Element => {
    const checkouts = useSelector(getCheckoutsStore);
    const { t } = useTranslation();
    const header = [t('status'), t('opened'), t('clicked')];
    const rows = useMobileTableRows();
    const { getDropdownActions, showCheckoutLinkModal } = useDropdownActions();
    const { hasAccessLevel } = useAccessLevel();
    const canModifyCheckouts = hasAccessLevel(AccessLevel.ModifyLandingPagesCheckout);
    const options = [
        {
            label: t('delete'),
            color: '#ff0000',
            value: DropdownOptions.Delete,
        },
    ];

    if (isEmpty(checkouts?.templatesList) && !checkouts?.loadingTemplates) {
        return (
            <Paper>
                <EmptyState text={t('emptystate')} />
            </Paper>
        );
    }

    return (
        <MobileTableContainer>
            <MobileTable
                headers={header}
                rows={rows}
                dropdownData={options}
                dropdownDataFilter={(opt) => getDropdownTableOptions(canModifyCheckouts)}
                onItemClick={(e, opt, checkout): void =>
                    getDropdownActions(opt as { label: string; value: DropdownOptions }, checkout)
                }
            />
        </MobileTableContainer>
    );
};